const INTRO_KEYS = {
    DMS: "DMS",
    MARKETPLACE: "MARKETPLACE",
    CONTRACTOR: "CONTRACTOR"
};
export default INTRO_KEYS;
